import { REPORT_STATUS_LABELS_FR } from '@ci-ville/shared';
/** Question posée avant de changer le statut d'un signalement ; le rejet demande son motif. */
export function statusConfirmOptions(status, currentReason) {
    switch (status) {
        case 'IN_PROGRESS':
            return {
                title: 'Prendre en charge ce signalement ?',
                message: `Le statut passera à « ${REPORT_STATUS_LABELS_FR.IN_PROGRESS} » et la personne qui a signalé en sera avisée.`,
            };
        case 'RESOLVED':
            return {
                title: 'Marquer ce signalement comme résolu ?',
                message: "La personne qui a signalé sera avisée du verdict et invitée à donner son avis.",
            };
        case 'REJECTED':
            return {
                title: 'Rejeter ce signalement ?',
                message: "La personne qui a signalé sera avisée du rejet et de son motif.",
                tone: 'danger',
                reason: {
                    label: 'Motif du rejet (visible par la personne qui a signalé)',
                    placeholder: 'Par exemple : ce secteur relève du ministère des Transports.',
                    defaultValue: currentReason ?? '',
                },
            };
        default:
            return { title: `Remettre ce signalement à « ${REPORT_STATUS_LABELS_FR[status]} » ?` };
    }
}
//# sourceMappingURL=confirm-status.js.map